

import qs from 'qs';
import Vue from 'vue';

Vue.prototype.$qs = qs;
window.qs = qs;

export default qs;
